<template>
    <date-picker
        type="date"
        :range="true"
        :default-value="range"
        v-model="range"
        valueType="date"
        :format="format"
        :clearable="false"
     />

</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


export default {
  name: "DateRangePicker",
  components: {
    DatePicker,
  },
  props: {
    startDate: {
      type: Date,
      default: function () {
        const date = new Date();
        date.setMonth(date.getMonth()-6);
        return date;
      }
    },
    endDate: {
      type: Date,
      default: function () {
        return new Date();
      }
    },
    format: {
      type: String,
      default: 'DD/MM/YYYY',
    }
  },
  data() {
    return {
      internalStartDate: null,
      internalEndDate: null,
      masks: {
        input: 'DD/MM/YYYY',
      },
    }
  },
  computed: {
    range: {
      get() {
        return [this.internalStartDate, this.internalEndDate];
      },
      set(val) {
        this.internalStartDate = val[0];
        this.internalEndDate = val[1];
      }
    }
  },
  watch: {
    internalStartDate(newValue) {
      this.$emit('update:startDate', newValue);
    },
    internalEndDate(newValue) {
      this.$emit('update:endDate', newValue);
    }

  },
  created() {
    this.internalStartDate = this.startDate;
    this.internalEndDate = this.endDate;
  }
}
</script>

<style lang="scss">
    .mx-input {
        padding-top: 18px;
        padding-bottom: 18px;
    }
</style>
